import React from 'react';
import { ROLES } from '../domain/constants';
import { roleCount, sortRoster } from '../domain/team';

export default function AuctionFinishedPanel({
    participants,
    teams,
    playersPerTeam,
    catalogue,
    onExport,
}) {
    return (
        <div className="panel">
            <div className="panel-header">
                <h2 className="panel-title">Asta conclusa</h2>
                <button type="button" className="btn btn--primary" onClick={onExport}>
                    Esporta squadre
                </button>
            </div>
            <div className="panel-body roster-grid">
                {participants.map((participant) => {
                    const team = teams[participant.id];
                    return (
                        <div key={participant.id} className="team panel">
                            <div className="team-header panel-header">
                                <h4>{team?.imported_name ?? participant.name}</h4>
                                <div className="team-budget">💰Residuo: {team?.budget ?? 0}</div>
                                <div className="team-roles">
                                    {ROLES.map((role) => (
                                        <span key={role} className="team-role" data-role={role}>
                                            {role} {roleCount(team, role)}/{playersPerTeam[role]}
                                        </span>
                                    ))}
                                </div>
                            </div>
                            <div className="team-roster">
                                {sortRoster(team?.roster).map((entry) => (
                                    <div key={entry.player_id} className="roster-row">
                                        <span className="roster-name u-truncate">
                                            {catalogue[entry.player_id]?.['Nome Completo'] ??
                                                `#${entry.player_id}`}{' '}
                                            ({entry.role})
                                        </span>
                                        <span className="roster-price num">{entry.purchase_price}</span>
                                    </div>
                                ))}
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}
